import Banner from "@/components/landing/contact/Banner";
import ContactForm from "@/components/landing/contact/ContactForm";
import Faqs from "@/components/landing/home/Faqs";

export default function Contact() {
  return (
    <>
      {/* Banner section */}
      <Banner />

      {/* Contact Form section */}
      <ContactForm />

      {/* Faqs section */}
      <Faqs />
    </>
  );
}
